module.exports = __webpack_public_path__ + "img/txt.d20ef35b.png";